<template>
  <v-container>
    <div class="text-h4">What is your PRI variant?</div>
    <v-select
      label="PRI Variant (Dynamic or TDM)"
      :value="currentISDN"
      persistent-hint
      hint="ISDN switch type"
      :items="switchTypes"
      @input="setPRIVariant"
    ></v-select>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'PRIVariant',
  data() {
    return {};
  },
  methods: {
    ...mapActions(['updateStoreFormData']),
    setPRIVariant(newVal) {
      this.updateStoreFormData({
        data: newVal,
        main: this.getProductIdSelected,
        sub: 'isdn',
      });
    },
  },
  mounted() {
    const product = this.getProductInfo;
    if (product.product_status !== 'completed') {
      this.updateStoreFormData({
        data: 'in_progress',
        main: this.getProductIdSelected,
        sub: 'product_status',
      });
    }
  },
  computed: {
    ...mapGetters(['getProductIdSelected', 'getProductInfo']),
    currentISDN() {
      const productInfo = this.getProductInfo();
      return productInfo.isdn;
    },
    switchTypes() {
      return [
        { text: 'Standard/NI2', value: 1 },
        { text: 'Custom/AT&T/5ESS', value: 2 },
        { text: 'Custom/DMS100', value: 3 },
        { text: 'Other', value: 4 },
        { text: 'Unknown', value: 5 },
      ];
    },
  },
};
</script>
